import { useTranslation } from 'react-i18next';
import { Dialog } from '@/common/components/Dialog/Dialog';
import { Icon } from '@/common/components/Icons/Icon';

export function SessionExpiredModal({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <Dialog
      icon={<Icon icon="lock" />}
      iconBadgeColor="accentSecondary20"
      title={t('session_expired_modal.title')}
      message={t('session_expired_modal.description')}
      onClose={onClose}
      primaryAction={{
        children: t('session_expired_modal.button_label'),
      }}
    />
  );
}
